import React from "react";
import "./Receptionist_card.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const Receptionist_card = ({
  title = "Receptionist",
  subTitle,
  name,
  id,
  email,
  contact,
  uploadedBy,
  uploadDate,
  documents = [],
  note,
  status,
  actions, // 👈 buttons via props
}) => {
  return (
    <div className="common_doc_card Receptionist_card">
      {/* Header */}
      <div className="card_header">
        <h5>{title}</h5>
        <span className="sub_title">{subTitle}</span>
      </div>

      {/* User Info */}
      <div className="user_info_holder">
        <div className="profile_text_img_holder">
          <div>
            <div className="profile_img_holder">
              <img className="profile_img" src="/assets/images/profile/profile_1.webp" alt="profile" />
            </div>
          </div>

          <div className="user_info">
            <h6>{name}</h6>
            <p>ID- {id}</p>
          </div>
        </div>

        <div className={`status_badge ${status.toLowerCase()}`}>{status}</div>
      </div>

      {/* Contact */}
      <div className="info_block">
        <p>
          Email:- <strong>{email}</strong>
        </p>
        <p>
          Contact:- <strong>{contact}</strong>
        </p>
      </div>

      {/* Schedule */}
      <div className="info_block schedule_div_info_block">
        <div className="schedule_div">
          <p>Arrival</p>
          <p className="details_text">{uploadedBy}</p>
        </div>
        <div className="schedule_div">
          <p>Start</p>
          <p className="details_text">{uploadDate}</p>
        </div>
        <div className="schedule_div">
          <p>End</p>
          <p className="details_text">{uploadDate}</p>
        </div>
      </div>

      {/* Documents */}
      <div className="documents_block">
        <h6>Documents Submitted</h6>
        {documents.map((item, index) => (
          <div key={index} className="document_item">
            <p>{item.doc}</p>
            <FontAwesomeIcon
              icon={item.icon}
              className={
                item.icon === faCircleCheck ? "check_icon" : "info_icon"
              }
            />
          </div>
        ))}
      </div>

      {/* Note */}
      <div className="documents_block">
        <h6>Note</h6>
        <p>{note}</p>
      </div>

      {/* ✅ ACTION BUTTONS */}
      <div className="action_btns">{actions}</div>
    </div>
  );
};

export default Receptionist_card;
